import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and merges Tailwind classes intelligently.
 * Based on shadcn/ui's cn utility.
 *
 * @example
 * cn("px-4 py-2", "px-6") // => "py-2 px-6" (px-6 overrides px-4)
 * cn("text-red-500", isActive && "text-blue-500") // conditional classes
 * cn("base-class", { "conditional": isTrue }) // object syntax
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
